import { TLocale } from '@/types/global';
import { getBaseUrl } from '@/utils/generic';

export const generateAboutStructuredData = (
  data: any,
  slug: string,
  locale: TLocale
) => {
  return {
    '@context': 'https://schema.org',
    '@type': 'OfferCatalog',
    name: 'Our Services',
    url: `${getBaseUrl()}/${locale ? locale + '/' : ''}${slug}`,
    provider: {
      '@type': 'Organization',
      name: 'Your Studio Name',
      url: getBaseUrl(),
    },
    itemListElement: [
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Branding',
          serviceType:
            'Brand Identity, Naming, Brand Architecture, Brand Voice, Editorial Design',
          // "url": "https://www.yourstudio.com/services/branding"
        },
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Architecture',
          serviceType:
            'Architecture, Interior Design, Landscape Design, Urban Planning',
          // "url": "https://www.yourstudio.com/services/architecture"
        },
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'visualization',
          serviceType:
            'CG Images, CG Film, CC Cinemagraph, Virtual Tour 360º, Video 360º',
          // "url": "https://www.yourstudio.com/services/visualization"
        },
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Photography & Film',
          serviceType:
            'Photoshoot, Film Production, Drone Filming, Studio Filming, Acting Direction',
          // "url": "https://www.yourstudio.com/services/photography-film"
        },
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Media',
          serviceType:
            'Books & Booklets, Collateral, Site Signage, Website, Interactive, Social Media',
          // "url": "https://www.yourstudio.com/services/media"
        },
      },
    ],
  };
};
